import { render, staticRenderFns } from "./BioPanel.vue?vue&type=template&id=6ba0da78"
import script from "./BioPanel.vue?vue&type=script&lang=js"
export * from "./BioPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports